module.exports = __webpack_public_path__ + "img/1481415422.41ed1bc2.jpg";